import { useContext } from "react";
import iconInfo from "../../assets/TopBar/iconInfo.svg";
import iconUser from "../../assets/TopBar/iconUser.svg";
import { getToken } from "../../services/auth";
import * as S from "./styles";
import * as Style from "../../shared/GlobalStyles/styles";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Dropdown from 'react-bootstrap/Dropdown';
import { IconUser } from "../../components/SideBar/styles";
import CadEmpresas from "../../pages/public/CadEmpresas";
import { DarkModeContext } from "../../contexts/darkMode";
import { ToggleDarkLight } from "../../components/ToggleDarkLight";
import * as GlobalStyle from '../GlobalStyles/styles'

let Icon = null;

const TopBar = () => {
  const [SectionName, setSectionName] = useState('');
  const [isOPenCompanies, setIsOPenCompanies] = useState(false);
  const {updateMode, darkModeButton, selectedTheme} = useContext(DarkModeContext)
  const colorSvg = JSON.parse(getToken('SISTESHOP')) ? darkModeButton ? '#5992fd' : selectedTheme.backgrounds.blue : selectedTheme.backgrounds.red2;
  let Companies = getToken('COMPANIES');
  Companies = Companies?.length > 0 ? JSON.parse(getToken('COMPANIES')) : {};
  const token = getToken('SISTESHOP');
  let verifySisteShop = JSON.parse(token)

  const {usuarioId, 
    mesa, id_mesa, id_delivery, id_cliente, id_entregador, id_frete, atendenteId, produtoId,
    grupoComplementoId, complementoId, vendaId, idPagamento, idReceita, idDespesa, idContasPagar, idContasReceber, idContaCorrente,
    idEntrada, pageNumber, idFabricante, idSecao, iDNcm, idCfop, id_televendas, editAllProduct, idEtiqueta, idSangriaSuprimento, idValeTroca
  } = useParams();

  const link = useLocation();
  const history = useHistory();

  const topBarSectionName = [
    {Icon: ({stroke}) => <GlobalStyle.IconHome stroke={stroke}/>, nome:'Dashboard', link:'/dashboard' },
    {Icon: ({stroke}) => <GlobalStyle.IconHome stroke={stroke}/>, nome:'Dashboard', link:'/dashboard/mesas' },
    {Icon: ({stroke}) => <GlobalStyle.IconHome stroke={stroke}/>, nome:'Dashboard', link:'/dashboard/delivery' },
    {Icon: ({stroke}) => <GlobalStyle.IconHome stroke={stroke}/>, nome:'Dashboard', link:'/dashboard/frenteLoja' },
    {Icon: ({fill, stroke}) => <GlobalStyle.IconAttendant fill={fill} stroke={stroke}/>, nome:'Atendentes', link:'/carregarAtendente'},
    {Icon: ({fill, stroke}) => <GlobalStyle.IconAttendant fill={fill} stroke={stroke}/>, nome:'Atendente', link:`/atendente/${atendenteId}`},
    {Icon: ({fill, stroke}) => <GlobalStyle.IconAttendant fill={fill} stroke={stroke}/>, nome:'Atendente', link:`/atendente`},
    {Icon: ({fill}) => <GlobalStyle.IconItems fill={fill}/>, nome:'itens', link:'/listarProduto'},
    {Icon: ({fill}) => <GlobalStyle.IconItems fill={fill}/>, nome:'itens', link:`/listarProduto/${pageNumber}`},
    {Icon: ({fill}) => <GlobalStyle.IconItems fill={fill}/>, nome:'itens', link:'/listarProdutoTelevendas'},
    {Icon: ({fill}) => <GlobalStyle.IconItems fill={fill}/>, nome:'itens', link:`/listarProdutoTelevendas/${pageNumber}`},
    {Icon: ({fill}) => <GlobalStyle.IconItems fill={fill}/>, nome:'itens', link:`/produtoTeleVendas/${pageNumber}`},
    {Icon: ({fill}) => <GlobalStyle.IconItems fill={fill}/>, nome: `item ${produtoId}`, link:`/produto/${produtoId}/${pageNumber}`},
    {Icon: ({fill}) => <GlobalStyle.IconItems fill={fill}/>, nome:'Item', link:'/produto'},
    {Icon: ({fill}) => <GlobalStyle.IconItems fill={fill}/>, nome:'Item', link:'/produto'},

    {Icon: ({fill}) => <GlobalStyle.IconItems fill={fill}/>, nome: `item ${produtoId}`, link:`/produtoTeleVendas/${produtoId}/${pageNumber}`},
    {Icon: ({fill}) => <GlobalStyle.IconItems fill={fill}/>, nome:'Item', link:'/listarProdutoTelevendas'},
 

    {Icon: ({fill}) => <GlobalStyle.IconItems fill={fill}/>, nome:'Categorias', link:'/Categoria'},
    {Icon: ({fill}) => <GlobalStyle.IconItems fill={fill}/>, nome:`Item ${produtoId}`, link:`/produto/${produtoId}`},
    {Icon: ({fill}) => <GlobalStyle.IconItems fill={fill}/>, nome:`Item ${produtoId}`, link:`/produtoTeleVendas/${produtoId}`},
    {Icon: ({fill}) => <GlobalStyle.IconSettings fill={fill}/>, nome:`Parâmetro`, link:`/parametro/DadosEmpresa`},
    {Icon: ({fill}) => <GlobalStyle.IconSettings fill={fill}/>, nome:`Parâmetro`, link:`/parametro/CardapioDigital`},
    {Icon: ({fill}) => <GlobalStyle.IconSettings fill={fill}/>, nome:`Parâmetro`, link:`/parametro/Delivery`},
    {Icon: ({fill}) => <GlobalStyle.IconSettings fill={fill}/>, nome:`Parâmetro`, link:`/parametro/Mesas`},
    {Icon: ({fill}) => <GlobalStyle.IconSettings fill={fill}/>, nome:`Parâmetro`, link:`/parametro/App`},
    {Icon: ({fill}) => <GlobalStyle.IconSettings fill={fill}/>, nome:`Parâmetro`, link:`/parametro/DFE`},
    {Icon: ({fill}) => <GlobalStyle.IconSettings fill={fill}/>, nome:'parâmetro', link:'/parametro'},
    {Icon: ({fill, stroke}) => <GlobalStyle.IconUserRouter fill={fill} stroke={stroke}/>, nome:'Usuários', link:'/listarUsuario'},
    {Icon: ({fill, stroke}) => <GlobalStyle.IconUserRouter fill={fill} stroke={stroke}/>, nome:`Usuário`, link:`/usuario/${usuarioId}`},
    {Icon: ({fill, stroke}) => <GlobalStyle.IconUserRouter fill={fill} stroke={stroke}/>, nome:`Usuário`, link:`/usuario/${usuarioId}`},
    {Icon: ({fill, stroke}) => <GlobalStyle.IconUserRouter fill={fill} stroke={stroke}/>, nome:`Usuário`, link:`/usuario`},
    {Icon: ({stroke}) => <GlobalStyle.IconTable stroke={stroke}/>, nome:'Mesas', link:'/CarregarMesas'},
    {Icon: ({stroke}) => <GlobalStyle.IconTable stroke={stroke}/>, nome:'Mesas', link:`/CarregarMesas/${mesa}/${id_mesa}`},
    {Icon: ({stroke}) => <GlobalStyle.IconTable stroke={stroke}/>, nome:'Mesas', link:`/CarregarMesas/FormaPagamento/${mesa}/${id_mesa}`},
    {Icon: ({stroke}) => <GlobalStyle.IconTable stroke={stroke}/>, nome:`Mesa ${mesa}`, link:`/AdicionarProdutoMesa/${mesa}/${id_mesa}`},
    {Icon: ({stroke}) => <GlobalStyle.IconTable stroke={stroke}/>, nome:`Mesa ${mesa}`, link:`/AdicionarProdutoMesa/${mesa}/${id_mesa}/AdicionarProduto`},
    {Icon: ({stroke}) => <GlobalStyle.IconTable stroke={stroke}/>, nome:`Mesa ${mesa}`, link:`/AdicionarProdutoMesa/FormaPagamento/${mesa}/${id_mesa}`},

    {Icon: ({stroke}) => <GlobalStyle.IconDelivery stroke={stroke}/>, nome:'Delivery', link:'/Delivery'},
    {Icon: ({stroke}) => <GlobalStyle.IconDelivery stroke={stroke}/>, nome:`Delivery ${id_delivery}`, link:`/Delivery/${id_delivery}`},
    {Icon: ({stroke}) => <GlobalStyle.IconDelivery stroke={stroke}/>, nome:`Novo delivery`, link:`/Delivery/LançarDelivery`},
    {Icon: ({stroke}) => <GlobalStyle.IconDelivery stroke={stroke}/>, nome:`Delivery ${id_delivery}`, link:`/AdicionarProdutoDelivery/${id_delivery}`},
    {Icon: ({stroke}) => <GlobalStyle.IconDelivery stroke={stroke}/>, nome:`Delivery ${id_delivery}`, link:`/AdicionarProdutoDelivery/${id_delivery}/AdicionarProduto`},
    {Icon: ({stroke}) => <GlobalStyle.IconDelivery stroke={stroke}/>, nome:`Delivery ${id_delivery}`, link:`/AdicionarProdutoDelivery/FormaPagamento/${id_delivery}`},

    {Icon: ({fill}) => <GlobalStyle.IconTeleSales fill={fill}/>, nome:'Televendas', link:'/Televendas'},
    {Icon: ({fill}) => <GlobalStyle.IconTeleSales fill={fill}/>, nome:`Televendas ${id_televendas}`, link:`/Televendas/${id_televendas}`},
    {Icon: ({fill}) => <GlobalStyle.IconTeleSales fill={fill}/>, nome:`Novo delivery`, link:`/Televendas/LancarTelevendas`},
    {Icon: ({fill}) => <GlobalStyle.IconTeleSales fill={fill}/>, nome:`Televendas ${id_televendas}`, link:`/AdicionarProdutoTelevendas/${id_televendas}`},
    {Icon: ({fill}) => <GlobalStyle.IconTeleSales fill={fill}/>, nome:`Televendas ${id_televendas}`, link:`/AdicionarProdutoTelevendas/${id_televendas}/AdicionarProduto`},
    {Icon: ({fill}) => <GlobalStyle.IconTeleSales fill={fill}/>, nome:`Televendas ${id_televendas}`, link:`/AdicionarProdutoTelevendas/${id_televendas}/AdicionarProduto/${editAllProduct}`},
    {Icon: ({fill}) => <GlobalStyle.IconTeleSales fill={fill}/>, nome:`Televendas ${id_televendas}`, link:`/AdicionarProdutoTelevendas/FormaPagamento/${id_televendas}`},

    {Icon: ({fill}) => <GlobalStyle.IconSale fill={fill}/>, nome:`Venda`, link:`/AdicionarProdutoVenda`},
    {Icon: ({fill}) => <GlobalStyle.IconSale fill={fill}/>, nome:`Venda`, link:`/AdicionarProdutoVenda/AdicionarProduto`},
    {Icon: ({fill}) => <GlobalStyle.IconSale fill={fill}/>, nome:`Venda`, link:`/AdicionarProdutoVenda/FormaPagamento`},
    {Icon: ({fill}) => <GlobalStyle.IconSale fill={fill}/>, nome:`NFCE`, link:`/AdicionarProdutoNFCE`},
    {Icon: ({fill}) => <GlobalStyle.IconSale fill={fill}/>, nome:`NFCE`, link:`/AdicionarProdutoNFCE/AdicionarProduto`},
    {Icon: ({fill}) => <GlobalStyle.IconSale fill={fill}/>, nome:`NFCE`, link:`/AdicionarProdutoNFCE/FormaPagamento`},

    {Icon: ({fill}) => <GlobalStyle.IconNFE fill={fill}/>, nome:`NF-e Entrada`, link:`/AdicionarProdutoEntradaNFE`},
    {Icon: ({fill}) => <GlobalStyle.IconNFE fill={fill}/>, nome:`NF-e Entrada`, link:`/AdicionarProdutoEntradaNFE/AdicionarProduto`},,
    {Icon: ({fill}) => <GlobalStyle.IconNFE fill={fill}/>, nome:`NF-e Saída`, link:`/AdicionarProdutoSaidaNFE`},
    {Icon: ({fill}) => <GlobalStyle.IconNFE fill={fill}/>, nome:`NF-e Saída`, link:`/AdicionarProdutoSaidaNFE/AdicionarProduto`},
    {Icon: ({fill}) => <GlobalStyle.IconPerson fill={fill} />, nome:'Clientes', link:'/listarCliente'},
    {Icon: ({fill}) => <GlobalStyle.IconPerson fill={fill} />, nome:'Cliente', link:`/listarCliente/${id_cliente}`},
    {Icon: ({fill}) => <GlobalStyle.IconPerson fill={fill} />, nome:'Cliente', link:`/cliente`},
    
    {Icon: ({fill}) => <GlobalStyle.IconDeliveryMan fill={fill}/>, nome:'Entregadores', link:'/listarEntregador'},
    {Icon: ({fill}) => <GlobalStyle.IconDeliveryMan fill={fill}/>, nome:'Entregador', link:'/Entregador'},
    {Icon: ({fill}) => <GlobalStyle.IconDeliveryMan fill={fill}/>, nome:'Entregador', link:`/Entregador/${id_entregador}`},

    {Icon: ({fill}) => <GlobalStyle.IconAPP fill={fill}/>, nome:'Qr Code', link:'/QrCode'},
    {Icon: ({stroke}) => <GlobalStyle.IconHome stroke={stroke}/>, nome:`Fretes`, link:`/listarFrete`},
    {Icon: ({stroke}) => <GlobalStyle.IconHome stroke={stroke}/>, nome:`Frete`, link:`/frete`},
    {Icon: ({fill}) => <GlobalStyle.IconFreight/>, nome:`Frete`, link:`/frete/${id_frete}`},
    {Icon: ({fill}) => <GlobalStyle.IconComplement fill={fill}/>, nome:`Complementos`, link:`/listarComplemento`},
    {Icon: ({fill}) => <GlobalStyle.IconComplement fill={fill}/>, nome:`Complemento`, link:`/Complemento`},
    {Icon: ({fill}) => <GlobalStyle.IconComplement fill={fill}/>, nome:`Complemento ${complementoId}`, link:`/Complemento/${complementoId}`},
    {Icon: ({fill}) => <GlobalStyle.IconGroupComplement fill={fill}/>, nome:`Grupo de Complementos`, link:`/listarGrupoComplemento`},
    {Icon: ({fill}) => <GlobalStyle.IconGroupComplement fill={fill}/>, nome:`Grupo de Complemento`, link:`/GrupoComplemento`},
    {Icon: ({fill}) => <GlobalStyle.IconGroupComplement fill={fill}/>, nome:`Grupo de Complemento ${grupoComplementoId}`, link:`/GrupoComplemento/${grupoComplementoId}`},
    {Icon: ({fill}) => <GlobalStyle.IconPerson fill={fill} />, nome:`Fabricante`, link:`/listarFabricante`},
    {Icon: ({fill}) => <GlobalStyle.IconPerson fill={fill} />, nome:`Fabricante`, link:`/Fabricante`},
    {Icon: ({fill}) => <GlobalStyle.IconPerson fill={fill} />, nome:`Fabricante ${idFabricante}`, link:`/Fabricante/${idFabricante}`},
    {Icon: ({fill}) => <GlobalStyle.IconSection fill={fill}/>, nome:`Seção`, link:`/listarSecao`},
    {Icon: ({fill}) => <GlobalStyle.IconSection fill={fill}/>, nome:`Seção`, link:`/Secao`},
    {Icon: ({fill}) => <GlobalStyle.IconSection fill={fill}/>, nome:`Seção ${idSecao}`, link:`/Secao/${idSecao}`},
    {Icon:  ({fill}) => <GlobalStyle.IconNcm fill={fill}/>, nome:`NCM`, link:`/listarNcm`},
    {Icon:  ({fill}) => <GlobalStyle.IconNcm fill={fill}/>, nome:`NCM`, link:`/Ncm`},
    {Icon:  ({fill}) => <GlobalStyle.IconNcm fill={fill}/>, nome:`NCM ${iDNcm}`, link:`/Ncm/${iDNcm}`},

    {Icon: ({fill}) => <GlobalStyle.IconCfop fill={fill}/>, nome:`CFOP`, link:`/listarCfop`},
    {Icon: ({fill}) => <GlobalStyle.IconCfop fill={fill}/>, nome:`CFOP`, link:`/Cfop`},
    {Icon: ({fill}) => <GlobalStyle.IconCfop fill={fill}/>, nome:`CFOP ${idCfop}`, link:`/Cfop/${idCfop}`},

    {Icon: ({fill}) => <GlobalStyle.IconLabel fill={fill}/>, nome:`Etiqueta`, link:`/listarEtiqueta`},
    {Icon: ({fill}) => <GlobalStyle.IconLabel fill={fill}/>, nome:`Etiqueta`, link:`/etiqueta`},
    {Icon: ({fill}) => <GlobalStyle.IconLabel fill={fill}/>, nome:`Etiqueta ${idEtiqueta}`, link:`/etiqueta/${idEtiqueta}`},

    {Icon: ({fill}) => <GlobalStyle.IconConsultSale fill={fill}/>, nome:`Consultar Vendas`, link:`/listarVendas`},
    {Icon: ({fill}) => <GlobalStyle.IconConsultSale fill={fill}/>, nome:`Venda ${vendaId}`, link:`/venda/${vendaId}`},
    {Icon: ({fill}) => <GlobalStyle.IconCurrency fill={fill}/> , nome:`Consultar Forma de Pagamento`, link:`/listarFormaPagamento`},
    {Icon: ({fill}) => <GlobalStyle.IconCurrency fill={fill}/>, nome:`Forma de Pagamento`, link:`/FormaPagamento/${idPagamento}`},
    {Icon: ({fill}) => <GlobalStyle.IconCurrency fill={fill}/>, nome:`Forma de Pagamento`, link:`/FormaPagamento`},
    {Icon: ({fill}) => <GlobalStyle.IconGraphUp fill={fill}/> , nome:`Consultar Receita`, link:`/listarReceita`},
    {Icon: ({fill}) => <GlobalStyle.IconGraphUp fill={fill}/>, nome:`Receita`, link:`/Receita/${idReceita}`},
    {Icon: ({fill}) => <GlobalStyle.IconGraphUp fill={fill}/>, nome:`Receita`, link:`/Receita`},
    {Icon: ({fill}) => <GlobalStyle.IconGraphDown fill={fill}/> , nome:`Consultar Despesa`, link:`/listarDespesa`},
    {Icon: ({fill}) => <GlobalStyle.IconGraphDown fill={fill}/>, nome:`Despesa`, link:`/Despesa/${idDespesa}`},
    {Icon: ({fill}) => <GlobalStyle.IconGraphDown fill={fill}/>, nome:`Despesa`, link:`/Despesa`},
    {Icon: ({fill}) => <GlobalStyle.IconBillsToPay fill={fill}/> , nome:`Consultar Pagar`, link:`/listarContasPagar`},
    {Icon: ({fill}) => <GlobalStyle.IconBillsToPay fill={fill}/> , nome:`Consultar Pagar`, link:`/listarContasPagar/${pageNumber}`},
    {Icon: ({fill}) => <GlobalStyle.IconBillsToPay fill={fill}/> , nome:`Consultar Pagas`, link:`/listarContasPagas`},
    {Icon: ({fill}) => <GlobalStyle.IconBillsToPay fill={fill}/> , nome:`Consultar Pagas`, link:`/listarContasPagas/${pageNumber}`},
    {Icon: ({fill}) => <GlobalStyle.IconBillsToPay fill={fill}/> , nome:`Consultar Canceladas`, link:`/listarContasCanceladas`},
    {Icon: ({fill}) => <GlobalStyle.IconBillsToPay fill={fill}/> , nome:`Consultar Canceladas`, link:`/listarContasCanceladas/${pageNumber}`},
    {Icon: ({fill}) => <GlobalStyle.IconBillsToPay fill={fill}/>, nome:`Pagar`, link:'/ContasPagar'},
    {Icon: ({fill}) => <GlobalStyle.IconBillsToPay fill={fill}/>, nome:`Pagar`, link:`/ContasPagar/${idContasPagar}/${pageNumber}`},
    {Icon: ({fill}) => <GlobalStyle.IconBillsToPay fill={fill}/>, nome:`Pagar`, link:`/ContasPagar/${idContasPagar}`},
    {Icon: ({fill}) => <GlobalStyle.IconBillsToPay fill={fill}/>, nome:`Pagas`, link:'/ContasPagas'},
    {Icon: ({fill}) => <GlobalStyle.IconBillsToPay fill={fill}/>, nome:`Pagas`, link:`/ContasPagas/${idContasPagar}/${pageNumber}`},
    {Icon: ({fill}) => <GlobalStyle.IconBillsToPay fill={fill}/>, nome:`Pagas`, link:`/ContasPagas${idContasPagar}`},
    {Icon: ({fill}) => <GlobalStyle.IconBillsToPay fill={fill}/>, nome:`Canceladas`, link:'/ContasCanceladas'},
    {Icon: ({fill}) => <GlobalStyle.IconBillsToPay fill={fill}/>, nome:`Canceladas`, link:`/ContasCanceladas/${idContasPagar}`},
    {Icon: ({fill}) => <GlobalStyle.IconBillsToPay fill={fill}/>, nome:`Canceladas`, link:`/ContasCanceladas/${idContasPagar}/${pageNumber}`},
    {Icon: ({fill}) => <GlobalStyle.IconBillsToReceive fill={fill}/> , nome:`Consultar Receber`, link:`/listarContasReceber`},
    {Icon: ({fill}) => <GlobalStyle.IconBillsToReceive fill={fill}/> , nome:`Consultar Receber`, link:`/listarContasReceber/${pageNumber}`},
    {Icon: ({fill}) => <GlobalStyle.IconBillsToReceive fill={fill}/> , nome:`Consultar Receber`, link:`/listarContasRecebidas`},
    {Icon: ({fill}) => <GlobalStyle.IconBillsToReceive fill={fill}/> , nome:`Consultar Receber`, link:`/listarContasReceberCanceladas/${pageNumber}`},
    {Icon: ({fill}) => <GlobalStyle.IconBillsToReceive fill={fill}/> , nome:`Consultar Receber`, link:`/listarContasReceberCanceladas`},
    {Icon: ({fill}) => <GlobalStyle.IconBillsToReceive fill={fill}/> , nome:`Consultar Receber`, link:`/listarContasRecebidas/${pageNumber}`},
    {Icon: ({fill}) => <GlobalStyle.IconBillsToReceive fill={fill}/> , nome:`Consultar Receber`, link:`/listarContasReceber/${idContasReceber}/${pageNumber}`},
    {Icon: ({fill}) => <GlobalStyle.IconBillsToReceive fill={fill}/>, nome:`Receber`, link:`/ContasReceber/${idContasReceber}/${pageNumber}`},
    {Icon: ({fill}) => <GlobalStyle.IconBillsToReceive fill={fill}/>, nome:`Receber`, link:`/ContasReceber/${idContasReceber}`},
    {Icon: ({fill}) => <GlobalStyle.IconBillsToReceive fill={fill}/>, nome:`Receber`, link:`/ContasReceber`},
    {Icon: ({fill}) => <GlobalStyle.IconCurrentAccount fill={fill}/> , nome:`Consultar Conta Corrente`, link:`/listarContaCorrente`},
    {Icon: ({fill}) => <GlobalStyle.IconCurrentAccount fill={fill}/>, nome:`Conta Corrente`, link:`/ContaCorrente/${idContaCorrente}`},
    {Icon: ({fill}) => <GlobalStyle.IconCurrentAccount fill={fill}/>, nome:`Conta Corrente`, link:`/ContaCorrente`},
    {Icon: ({fill}) => <GlobalStyle.IconConsultNoteEntry fill={fill}/>  , nome:`Consultar Entrada`, link:`/listarNotasEntrada`},
    {Icon: ({fill}) => <GlobalStyle.IconConsultNoteEntry fill={fill}/> , nome:`Entrada ${idEntrada}`, link:`/entrada/${idEntrada}`},
    {Icon: ({fill}) => <GlobalStyle.IconNoteEntry fill={fill}/> , nome:`Entrada de Nota`, link:`/AdicionarProdutoEntrada`},
    {Icon: ({fill}) => <GlobalStyle.IconNoteEntry fill={fill}/> , nome:`Entrada de Nota Forma de Pagamento`, link:`/AdicionarProdutoEntrada/FormaPagamento`},
    {Icon: ({fill}) => <GlobalStyle.IconNoteEntry fill={fill}/>, nome:`Entrada de Nota Produtos`, link:`/AdicionarProdutoEntrada/AdicionarProduto`},
    {Icon: ({fill}) => <GlobalStyle.IconNoteSingle fill={fill}/> , nome:`Nota Avulsa`, link:`/NotaAvulsa`},
    {Icon: ({fill}) => <GlobalStyle.IconNoteSingle fill={fill}/>, nome:`Nota Avulsa Produtos`, link:`/NotaAvulsa/AdicionarProduto`},
    {Icon: ({fill}) => <GlobalStyle.IconInventory fill={fill}/> , nome:`Inventário`, link:`/Inventario`},
    {Icon: ({fill}) => <GlobalStyle.IconInventory fill={fill}/>, nome:`Inventário Produtos`, link:`/Inventario/AdicionarProduto`},
    {Icon: ({fill}) => <GlobalStyle.IconSangriaAndSupply fill={fill}/> , nome:`Sangria e Suprimento`, link:`/listarSangriaSuprimento`},
    {Icon: ({fill}) => <GlobalStyle.IconSangriaAndSupply fill={fill}/>, nome:`Sangria e Suprimento ${idSangriaSuprimento}`, link:`/sangriaSuprimento/${idSangriaSuprimento}`},
    {Icon: ({fill}) => <GlobalStyle.IconWorthExchange fill={fill}/> , nome:`Vale Troca`, link:`/listarValeTroca`},
    {Icon: ({fill}) => <GlobalStyle.IconWorthExchange fill={fill}/>, nome:`Vale Troca ${idValeTroca}`, link:`/valeTroca/${idValeTroca}`},
  ]

  useEffect(() => {
    verifyNameUrl()
  }, [link.pathname])

  const verifyNameUrl = () => { 
    topBarSectionName.filter(item => {
      if (link.pathname === item.link) {
        if(item?.Icon) Icon = item.Icon
        setSectionName(item.nome);
      }
      return
    })
  }

  const handleClickCompanies = () => {if(Companies?.cnpj) setIsOPenCompanies(true)};

  const closeModalCampanies = () => setIsOPenCompanies(false);

  const verifySideBar = () => {
    const sideBar = JSON.parse(getToken('SIDEBAR'));
    if(sideBar?.televendas)return history.push('/Televendas') ;
    history.push('/dashboard')
  }

  return (
    <S.Container >
      <S.ContainerLogoFood>
        <S.ContainerWrapperLogoFood >
          <S.IconLogo onClick={verifySideBar}>

            {
              verifySisteShop ? <Style.IconLogoBlue fill={darkModeButton ? '#5992fd' : '#000033'} fill2={darkModeButton ? '#5992fd' : '#0B02C1'}/>
              : <Style.IconLogoRed fill={darkModeButton ? '#d1cdc7' : selectedTheme.backgrounds.red2} fill2={darkModeButton ? '#d1cdc7' : '#03134F'}/>
            }
            
          </S.IconLogo>
        </S.ContainerWrapperLogoFood>
      </S.ContainerLogoFood>

      <S.InforHeaderWrapper>
        <S.StablishmentNameContainer cursor={Companies?.cnpj?.length > 0 ? 'pointer' : 'auto'} onClick={handleClickCompanies}>
          <S.IconStablishment  stroke={colorSvg}  />
          <p>{getToken('NOMEEMPRESA') }</p>
        </S.StablishmentNameContainer>

        <S.Button darkTheme={darkModeButton} themeColor={darkModeButton ? !verifySisteShop ? selectedTheme.colors.black : '#96b9fb' : selectedTheme.backgrounds.blue4}>
          <S.ImageContainer>
            {
              Icon && <Icon 
                fill={darkModeButton ? !verifySisteShop ? '#d1cdc7' : '#5992fd' : selectedTheme.backgrounds.blue4} 
                stroke={darkModeButton ? !verifySisteShop ? '#d1cdc7' : '#5992fd' : selectedTheme.backgrounds.blue4}
              />
            }
          </S.ImageContainer>
          {SectionName}
        </S.Button>

        <S.UserInfoContainer>
          <S.CertificateInfoContainer>
            <S.iconCalendar fill={colorSvg}/>

            <p>{`restam: ${getToken("DIAS")} dias`}</p>
            
            <S.ImageContainer>
              <img src={iconInfo} alt='Ícone info'/>
            </S.ImageContainer>
          </S.CertificateInfoContainer>
          
          <S.UserInfo>
            <p>{`${getToken("LOGIN")}`}</p>
            
            <S.ImageUserContainer>
              <img src={iconUser} alt='Ícone do usuário'/>
            </S.ImageUserContainer>

            <ToggleDarkLight 
              handleToggle={updateMode}
              isChecked={darkModeButton}
              checked={darkModeButton}
            />
          </S.UserInfo>

          <S.UserInfoDropDown darkmodebutton={darkModeButton}>
            <Dropdown>
              <Dropdown.Toggle variant='none' bsPrefix={'my-css'}>
                <S.ContainerDropDownIconUser>
                  <S.ImageUserContainer>
                    <img src={iconUser} alt='Ícone do usuário'/>
                  </S.ImageUserContainer>
                  <Style.IconArrowDown stroke={colorSvg}/>

                </S.ContainerDropDownIconUser>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item className="dropdown-icon" >
                  <S.ImageUserContainer width={'20px'} height={'20px'}>
                    <IconUser 
                      fill={colorSvg}
                      stroke={colorSvg}
                    />
                  </S.ImageUserContainer>
                  <p>{getToken('LOGIN')}</p>
                </Dropdown.Item>
                <Dropdown.Item className="dropdown-icon" >
                  <S.iconCalendar fill={colorSvg}/>
                  <p>{`restam: ${getToken("DIAS")} dias`}</p>
                  </Dropdown.Item>
                <Dropdown.Item className="dropdown-icon establishment-name" onClick={handleClickCompanies} >
                  <S.IconStablishment  stroke={colorSvg} />
                  <p>{getToken('NOMEEMPRESA')}</p>
                </Dropdown.Item>

                <Dropdown.Item onClick={updateMode}>
                  <ToggleDarkLight 
                    handleToggle={updateMode}
                    isChecked={darkModeButton}
                    checked={darkModeButton}
                  />
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </S.UserInfoDropDown>

        </S.UserInfoContainer>
      </S.InforHeaderWrapper>

      {
        isOPenCompanies ? (
          <CadEmpresas 
            onClose={closeModalCampanies} 
            resultado={Companies}
          />
          ): null

      }
    </S.Container>
 
  );
};

export default TopBar;
